import React from "react";
import historia1 from "../assets/historia1.webp";
import historia2 from "../assets/historia2.png";

const FIGURES = [
  {
    src: historia2,
    alt: "Servicios y testimonios en el sitio original del despacho",
    caption:
      "Servicios, testimonios y contacto tal como los presentábamos entonces.",
  },
  {
    src: historia1,
    alt: "Sitio web original de Contreras & Asociados PV",
    caption: "Nuestro primer sitio web — el rostro del despacho durante años.",
  },
];

const HistoriaFigure = ({ src, alt, caption }) => (
  <figure>
    <img src={src} alt={alt} loading="lazy" />
    <figcaption>{caption}</figcaption>
  </figure>
);

const HistoriaAside = () => (
  <aside className="historia-aside">
    <div className="eyebrow">
      <span className="diamond">◆</span> NUESTRA HISTORIA
    </div>
    <h2>
      Defendiendo sus derechos
      <br />
      desde 1986
    </h2>
    <p>
      Contreras &amp; Asociados PV nació en Puerto Vallarta cuando el auge del
      tiempo compartido en la Bahía de Banderas comenzaba a transformar la
      región. Desde entonces hemos acompañado a miles de familias mexicanas,
      estadounidenses y canadienses en la defensa de sus derechos como
      consumidores.
    </p>
    <p>
      Estas imágenes de nuestro sitio original recuerdan de dónde venimos: casi
      cuatro décadas de trabajo constante, resultados reales y trato cercano con
      cada cliente.
    </p>
  </aside>
);

const NuestraHistoria = () => (
  <section id="historia" className="historia">
    <div className="wrap historia-grid">
      <HistoriaAside />
      <div className="historia-media">
        {FIGURES.map((fig) => (
          <HistoriaFigure key={fig.src} {...fig} />
        ))}
      </div>
    </div>
  </section>
);

export default NuestraHistoria;
